export const EXAMS={
    'jee-main':{
        NAME:'JEE MAIN',
        TYPE:'JEE(M)',
        SUB_HEADING:'JEE Main'
    },
    'jee-advanced':{
        NAME:'JEE ADVANCED',
        TYPE:'JEE(A)',
        SUB_HEADING:'JEE Advanced'
    }
}

export const DEFAULT_TITLE={
    LOCATION: 'Select Location',
    BRANCH: 'Select Branch',
    COURSE: 'Select Course',
    LOW_TO_HIGH: 'Low To High',
    HIGH_TO_LOW: 'High To Low',
    LOW_TO_HIGH_RANK: 'Low To High rank',
    HIGH_TO_LOW_RANK: 'High To Low rank',
    EXAM:'jee-main',
    COLLEGE_IMG: '/assets/img/s3-images/picasso/college-predictor/college-default-img.svg'
}

export const BRANCH_ICON = {
    Aeronautical: 'aeronautical.svg',
    Agricultural: 'agricultural.svg',
    Architecture: 'architecture.svg',
    'Bio Technology': 'bio-technology.svg',
    Chemical: 'chemical.svg',
    Civil: 'civil.svg',
    'Computer Science' : 'computer-science.svg',
    Economics: 'economics.svg',
    Electrical: 'electrical.svg',
    Electronics: 'electronics.svg',
    Environmental: 'environmental.svg',
    'General Science':'general-science.svg',
    GeoTechnical: 'geo-technical.svg',
    'Information Technology': 'information-technology.svg',
    Instrumentation: 'instrumentation.svg',
    Marine: 'marine.svg',
    Material: 'material.svg',
    Mathematics: 'mathematics.svg',
    Mechanical: 'mechanical.svg',
    'Metallurgy & Mining': 'metallurgy-&-mining.svg',
    'Petroleum & Energy': 'petroleum-&-energy.svg',
    Pharmaceutical: 'pharmaceutical.svg',
    Physics: 'physics.svg',
    Textile: 'textile.svg'
};